// extracted by mini-css-extract-plugin
export default {"forgotPasswordTitle":"ForgotPassword_forgotPasswordTitle__TrrYz"};